import { Bone } from "@/components/Bone";
import { BoneLine, BoneTitle, Skeleton } from "@/components/PageSkeleton";

import styles from "./ReadingJobScreen.module.css";

/** The region's name for a screen reader while a reading loads. */
export const READING_LOADING = "Lesung wird geladen";

/**
 * „Zeichnung lesen" in its own geometry while the job and the Vorgang load
 * (Task 10; UX review 26.10.2026, B-4), built from the screen's classes: the
 * title; the steps and the status line beside the sheet, the sheet with its
 * caption and its landscape place. Under the frame that already names the
 * Vorgang — never „Die Lesung wird geladen …".
 */
export function ReadingSkeleton() {
  return (
    <Skeleton label={READING_LOADING} className={`${styles.screen} ${styles.withSheet}`}>
      <BoneTitle width="9rem" />
      <div className={styles.layout} aria-hidden="true">
        <div className={styles.side}>
          <div className={styles.steps}>
            {[0, 1, 2].map((step) => (
              <Bone key={step} height="3.25rem" />
            ))}
          </div>
          <div className={styles.status}>
            <Bone width="90%" />
            <Bone width="60%" />
          </div>
        </div>
        <div className={styles.sheet}>
          <div className={styles.sheetHead}>
            <BoneLine className="label" width="7rem" height="0.625rem" />
          </div>
          <div className={styles.sheetBody}>
            <div className={styles.sheetWait} />
          </div>
        </div>
      </div>
    </Skeleton>
  );
}
